import React from 'react';
import loadable from 'react-loadable';

export default loadable({
	loader: () => import('./mmtHeader' /* webpackChunkName: 'mmtHeader' */),
	loading: () => null,
	modules: ['mmtHeader']
});
